import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { HousesContextProvider } from './context/HousesContext';
import { UserContextProvider } from './context/UserContext';

export const theme = createTheme({
    palette: {
        primary: {
            main: '#1976D2',
        },
        secondary: {
            main: '#40C4FF',
        },
        fancy: {
            main: `linear-gradient(to right, #1976D2, #40C4FF)`,
        },
        fancyInverted: {
            main: `linear-gradient(to right, #40C4FF, #1976D2)`,
        },
        middle: {
            main: '#0A6BAC',
        },
    },
    typography: {
        fontFamily: ['Poppins', 'Roboto'].join(','),
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <ThemeProvider theme={theme}>
        <React.StrictMode>
            <UserContextProvider>
                <HousesContextProvider>
                    <App />
                </HousesContextProvider>
            </UserContextProvider>
        </React.StrictMode>
    </ThemeProvider>
);

reportWebVitals();
